import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=90944e7c&scoped=true&"
import script from "./Notifier.vue?vue&type=script&lang=js&"
export * from "./Notifier.vue?vue&type=script&lang=js&"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=90944e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90944e7c",
  null
  
)

export default component.exports